import { theme } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';

const useThankYou = () => {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const shop_url = searchParams.get('shop_url');

  const goLogin = () => {
    navigate('/login');
  };

  const viewWebsite = () => {
    window.location = `https://${shop_url}.sipro.store`;
  };

  return {
    token,
    shop_url,
    goLogin,
    viewWebsite,
  };
};

export default useThankYou;
